<template>
  <div class="page page-about">
    <section class="section">
      <div class="section-inner">
        <div class="section-header">
          <h2 class="section-title">公司介绍</h2>
          <p class="section-subtitle">南京壹零壹陆信息科技有限公司</p>
        </div>
        <div class="about-body">
          <p>
            南京壹零壹陆信息科技有限公司面向企业客户提供信息化与数字化相关服务，
            覆盖咨询规划、系统落地与持续运营支持。
          </p>
          <p>
            我们坚持以业务目标为导向，帮助团队把需求转化为可执行、可维护的解决方案。
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.page {
  background: #f4f8fc;
}

.about-body {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-left: 4px solid #0284c7;
  border-radius: 0;
  padding: 24px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.9;
}

.about-body p + p {
  margin-top: 14px;
}
</style>
